import "core-js/modules/es.array.concat.js";
function formatDate(d) {
  var date = new Date(d);
  var y = date.getFullYear();
  var m = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0".concat(date.getMonth() + 1);
  var day = date.getDate() > 9 ? date.getDate() : "0".concat(date.getDate());
  return "".concat(y, "-").concat(m, "-").concat(day);
}
var states = {
  defaultSearchForm: {
    // 默认检索条件用于初始化使用
    pageNum: 1,
    pageSize: 10,
    requestVO: {
      filterField: {
        issueNum: null,
        instTitle: null,
        issueType: [],
        instTypeName: null,
        instCategory: ['INSTITUTION'],
        publishDateEnd: formatDate(new Date()),
        publishDateStart: '1970-01-01',
        daterange: ['1970-01-01', formatDate(new Date())],
        publishOrg: [],
        status: ['VALID', 'NOT_VALID_YET'],
        type: [],
        instType: [],
        periodDate: []
      },
      key: null,
      sortReq: {
        field: 'SCORE',
        // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
        order: 'DESC'
      },
      precise: true
    }
  },
  searchForm: {
    // 检索条件
    pageNum: 1,
    pageSize: 10,
    requestVO: {
      filterField: {
        issueNum: null,
        instTitle: null,
        issueType: [],
        instTypeName: null,
        instCategory: ['INSTITUTION'],
        publishDateEnd: formatDate(new Date()),
        publishDateStart: '1970-01-01',
        daterange: ['1970-01-01', formatDate(new Date())],
        publishOrg: [],
        status: ['VALID', 'NOT_VALID_YET'],
        type: [],
        instType: [],
        periodDate: []
      },
      key: null,
      sortReq: {
        field: 'SCORE',
        // 字段,可用值:EFFECTIVE_DATE,PUBLISH_DATE,PUBLISH_ORG,SCORE,示例值(PUBLISH_ORG)
        order: 'DESC'
      },
      precise: true
    }
  }
};
var mutations = {
  SET_SEARCH_FORM: function SET_SEARCH_FORM(state, obj) {
    state.searchForm = obj;
  },
  SET_FROM_DATE: function SET_FROM_DATE(state, arr) {
    if (arr) {
      state.searchForm.requestVO.filterField.publishDateStart = arr.daterange[0];
      state.searchForm.requestVO.filterField.publishDateEnd = arr.daterange[1];
    } else {
      state.searchForm.requestVO.filterField.publishDateStart = null;
      state.searchForm.requestVO.filterField.publishDateEnd = null;
    }
  },
  RESET_FROM: function RESET_FROM(state) {
    state.defaultSearchForm.requestVO.filterField.status = ['VALID', 'NOT_VALID_YET'];
    state.searchForm = JSON.parse(JSON.stringify(state.defaultSearchForm));
  },
  NORMAL_SEARCH: function NORMAL_SEARCH(state) {
    state.searchForm.requestVO.filterField = JSON.parse(JSON.stringify(state.defaultSearchForm.requestVO.filterField));
  },
  SET_Form_Status: function SET_Form_Status(state, arr) {
    state.searchForm.requestVO.filterField.status = arr;
  }
};
var actions = {
  resetSearchForm: function resetSearchForm(_ref) {
    var commit = _ref.commit;
    // 重置
    commit('RESET_FROM');
  },
  changeFormDate: function changeFormDate(_ref2, daterange) {
    var commit = _ref2.commit;
    // 修改时间
    commit('SET_FROM_DATE', daterange);
  },
  normalSearchForm: function normalSearchForm(_ref3) {
    var commit = _ref3.commit;
    // 普通搜索
    commit('NORMAL_SEARCH');
  },
  setSearchForm: function setSearchForm(_ref4, obj) {
    var commit = _ref4.commit;
    commit('SET_SEARCH_FORM', obj);
  },
  setFormStatus: function setFormStatus(_ref5, obj) {
    var commit = _ref5.commit;
    commit('SET_Form_Status', obj);
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};

// searchForm